import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../../collection'
import type { Feature } from '../feature'

/** Clears the file input and reloads the selected source after an upload. */
export const handleUploadSuccess = store.effects.create(
  (feature: Feature, collection: Collection) =>
    collection.fileOperations.actions.upload.success
      .observe()
      .pipe(
        rxjs.mergeMap(action =>
          rxjs.of(
            feature.actions.clearSelectedFile.from(action).create(),
            collection.plugins.currentListPlugin.feature.actions.load
              .from(action)
              .create(),
          ),
        ),
      ),
)
